import React from "react";
import "./Aboute.css";
import Header from "../../components/Header/Header";

export default function Aboute() {
  return (
    <div>
      <Header />
      <section className="about-section">
        <div className="about-container">
          {/* Գլխավոր Նկար */}
          <div className="about-image">
            <img src="/about-img.png" alt="Մեր մասին" />
          </div>

          {/* Բովանդակություն */}
          <div className="about-content">
            <h2 className="about-title">Մեր մասին</h2>

            <p className="about-text">
              Malongo-ն հիմնադրվել է 1934 թվականին Ֆրանսիայի Նիս քաղաքում և այսօր համարվում է
              երկրի ամենահայտնի պրեմիում սուրճ արտադրողներից։ Ավելի քան 90 տարվա փորձը
              ձևավորել է յուրահատուկ բովման ավանդույթ՝ 20 րոպե տևողությամբ դանդաղ և խորը
              բովում (220°C), որը բացահայտում է յուրաքանչյուր հատիկի իսկական բույրն ու համը։
            </p>

            <p className="about-text">
              Հայաստանում Malongo-ի պաշտոնական դիստրիբյուտորը Բրենդ Բրիջ ՍՊԸ-ն է, որը
              շուկայում է շուրջ 10 տարի և զբաղվում է ինչպես սուրճի ներմուծմամբ, այնպես էլ
              սուրճի մեքենաների ներմուծմամբ և տեխնիկական սպասարկմամբ։ Ունենալով միաժամանակ
              բարձրորակ սուրճի, ինչպես նաև սուրճի մեքենաների վաճառք և սպասարկում՝ մենք
              ապահովում ենք իսկական սուրճ վայելելու ամբողջական լուծումներ թե՛ տան, թե՛
              գրասենյակների, թե՛ հյուրանոցների համար։
            </p>

            <p className="about-text">
              Այսպիսով մենք առաջարկում ենք հուսալի գործընկերություն՝ մշտական մատակարարում,
              խորհրդատվություն և բրենդային փաթեթավորում։
            </p>

            {/* Ինչու ընտրել Malongo */}
            <div className="about-section-block">
              <h3 className="about-subtitle">Ինչու ընտրել Malongo</h3>
              <p className="about-text">
                Պայմանավորված հայաստանյան շուկայում հաճախորդների՝ որակյալ սուրճ ըմպելու
                պահանջով, մենք ուսումնասիրեցինք Malongo բրենդը և հասկացանք, որ այն ունի
                պրեմիում կարգի սուրճ համարվելու բոլոր հատկանիշները, որոնք կբավարարեն մեր
                սպառողների պահանջները։
              </p>
              <p className="about-text">
                Malongo-ն աշխատում է ընտրյալ պլանտացիաների հետ աշխարհի տարբեր
                տարածաշրջաններում՝ Ջամայկա, Բուրունդի, Կոնգո, Գվատեմալա, Մեքսիկա, Լաոս,
                Պերու, Միյանմար, Դոմինիկյան Հանրապետություն և Եթովպիա։ Բրենդը
                մասնագիտանում է բարձրակարգ խառնումներով և յուրահատուկ ծագման սուրճերով,
                որոնք սիրված են գուրմանների կողմից։
              </p>
              <p className="about-text">
                Malongo-ի ամենահայտնի տեսակներից է Blue Mountain specialty սուրճը, որն
                աճեցված է Ջամայկայի Blue Mountain լեռնաշղթայում։ Այն աշխարհի
                ամենաբարձրակարգ և փափուկ արաբիկա սուրճերից է։
              </p>
            </div>

            {/* Առավելություններ */}
            <div className="about-section-block">
              <h3 className="about-subtitle">Malongo-ի առավելությունները</h3>
              <ul className="about-list">
                <li>Ավանդական ֆրանսիական բովում՝ հարուստ բույր և ներդաշնակ համ։</li>
                <li>100% բնական և օրգանական ծագում՝ առանց հավելումների։</li>
                <li>Fair Trade և EcoCert սերտիֆիկացված արտադրություն՝ կայուն զարգացման համար։</li>
                <li>
                  Ֆրանսիական վարպետություն և անփոխարինելի որակ՝ գնահատված աշխարհի լավագույն
                  հյուրանոցներում՝ Radisson Blu, Rixos, Hayat, Ritz, Sofitel, MonacoSBL և
                  այլ վայրերում։ Malongo սուրճը մատուցվում է նաև Ելիսեյան պալատում։
                </li>
              </ul>
            </div>

            {/* Մեր առաջարկը կազմակերպություններին */}
            <div className="about-section-block">
              <h3 className="about-subtitle">Մեր առաջարկը կազմակերպություններին</h3>
              <p className="about-text">
                Մենք առաջարկում ենք պրեմիում սուրճ՝ նախատեսված հյուրանոցների, սրճարանների,
                ռեստորանների, բիզնես կենտրոնների և գրասենյակների համար։ Բացի սուրճից՝ մենք
                տրամադրում ենք սուրճի մեքենաների վաճառք, տեղադրում և տեխնիկական սպասարկում՝
                ապահովելով ձեր կազմակերպության համար ամբողջական և հուսալի սուրճի համակարգ։
              </p>
              <p className="about-text">
                Բրենդ Բրիջ ընկերությունը ներկայացնում է նաև ֆրանսիական ոճի Pascali սրճարան-
                բուտիկը՝ Մոսկովյան 28 հասցեում, որտեղ կարող եք ծանոթանալ Malongo սուրճերի
                տեսականուն և վայելել սուրճը տեղում։
              </p>
            </div>

            {/* Կոնտակտ */}
            <div className="about-section-block">
              <h3 className="about-subtitle">Պաշտոնական դիստրիբյուտոր Հայաստանում — Բրենդ Բրիջ ՍՊԸ</h3>
              <p className="about-text">Մոսկովյան 28, Երևան</p>
              <p className="about-text">Tel: 096 58 44 58</p>
              <p className="about-text">info@brandbridge.am</p>
            </div>

            <a href="/contact" className="about-button">Կապ հաստատել մեզ հետ</a>
          </div>
        </div>
      </section>
    </div>
  );
}
